<template>
  <div class="h-dialogContainer">
    <form id="noRealSingleReport">
      <div class="row">
        <div class="col-sm-6">
          <div class="h-col-inputBox-left">
            <div class="h-inputLit">{{$t('Pm.timeRange')}}</div>
            <ejs-radiobutton :label='$t("Pm.today")' name="timeRange" :checked="true" value="0" :change="changeOfTimeRange"></ejs-radiobutton>
            <ejs-radiobutton :label='$t("Pm.yesterday")' name="timeRange" value="1" :change="changeOfTimeRange"></ejs-radiobutton>
            <ejs-radiobutton :label='$t("Pm.currentWeek")' name="timeRange" value="2" :change="changeOfTimeRange"></ejs-radiobutton>
            <ejs-radiobutton :label='$t("Pm.lastWeek")' name="timeRange" value="3" :change="changeOfTimeRange"></ejs-radiobutton>
            <ejs-radiobutton :label='$t("Pm.specified")' name="timeRange" value="4" :change="changeOfTimeRange"></ejs-radiobutton>
          </div>
          <div class="h-col-inputBox-left">
            <div class="h-inputLit">{{$t('Pm.start_time')}}</div>
            <ejs-datetimepicker :locale='locale' :change='validateOfNoRealMeasurementReport' :format='dateFormat' name="startTimeForSingle" :enabled='startTimeEnabled' v-model='startTimeForSingle'></ejs-datetimepicker>
          </div>
          <div class="h-col-inputBox-left">
            <div class="h-inputLit">{{$t('Pm.end_time')}}</div>
            <ejs-datetimepicker :locale='locale' :change='validateOfNoRealMeasurementReport' :format='dateFormat' name="endTimeForSingle" :enabled='endTimeEnabled' v-model='endTimeForSingle'></ejs-datetimepicker>
          </div>
          <div class="h-col-inputBox-left">
            <div class="h-inputLit">{{$t('Pm.measureCycle')}}</div>
            <ejs-dropdownlist :dataSource="dataSourceOfSampleTime" :fields="filedsOfSampleTime" v-model="sampleTimeOfSingleReport"></ejs-dropdownlist>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="h-col-inputBox-right">
            <div class="h-inputLit">{{$t('Pm.measureObj')}}</div>
            <ejs-listview :dataSource='measureObjDataSourceOfSingleReport' :showIcon='true' :fields="measureObjFiledsOfSingleReport" :select="measureObjSelectedOfMeasurementReport"></ejs-listview>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="h-col-inputBox-middle">
            <div class="h-inputLit">{{$t('Pm.counterList')}}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="h-borderBox height-250">
            <NoRealTaskMeasureTreeForSingleReport ref="NoRealTaskMeasureTreeForSingleReport"></NoRealTaskMeasureTreeForSingleReport>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import DateUtil from "../../../../util/DateUtil";
  import {FormValidator} from "@syncfusion/ej2-vue-inputs";
  import CommonUtil from "../../../../util/CommonUtil";
  import NoRealTaskMeasureTreeForSingleReport from "../tree/NoRealTaskMeasureTreeForSingleReport";

  export default {
    name: 'NoRealTaskMeasurementReportDialog',
    components: {NoRealTaskMeasureTreeForSingleReport},
    props: [
      'selectNeId',
      'selectNeType'
    ],
    data() {
      return {
        startTimeEnabled: false,
        endTimeEnabled: false,
        startTimeForSingle: new Date(`${DateUtil.getTodayYearMonthDay()} 00:00:00`),
        endTimeForSingle: new Date(`${DateUtil.getTodayYearMonthDay()} 23:59:59`),
        locale: localStorage.getItem('locale'),
        dateFormat: 'yyyy-MM-dd HH:mm:ss',
        dataSourceOfSampleTime: [{
          cycle: `5${this.$t('Pm.minutes')}`, value: 300000},
          {cycle: `15${this.$t('Pm.minutes')}`, value: 900000},
          {cycle: `30${this.$t('Pm.minutes')}`, value: 1800000},
          {cycle: `60${this.$t('Pm.minutes')}`, value: 3600000},
          {cycle: `24${this.$t('Pm.hours')}`, value: 86400000},
        ],
        filedsOfSampleTime: {
          text: 'cycle',
          value: 'value'
        },
        sampleTimeOfSingleReport: 900000,
        measureObjDataSourceOfSingleReport: [],
        measureObjFiledsOfSingleReport: {
          text: 'measureObjNameCH',
          value: 'measureObjCode',
        },
        measureObjCodeOfSingleReport: 1,
        optionsOfNoRealSingleReportDialogValidation: {
          customPlacement(inputElement, errorElement) {
            errorElement.style.position = 'fixed';
            inputElement.parentElement.parentElement.appendChild(errorElement);
          },
          rules: {
            startTimeForSingle: {
              required: [true, this.$t('Pm.begTimeNull')],
              regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, this.$t('Pm.begTimeFormatError')]
            },
            endTimeForSingle: {
              required: [true, this.$t('Pm.endTimeNull')],
              regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, this.$t('Pm.endTimeFormatError')]
            }
          }
        },
        formObjOfNoRealSingleReport: ''
      }
    },
    methods: {
      changeOfTimeRange(args) {
        switch (args.value) {
          case '0':
            this.startTimeForSingle = new Date(`${DateUtil.getTodayYearMonthDay()} 00:00:00`);
            this.endTimeForSingle = new Date(`${DateUtil.getTodayYearMonthDay()} 23:59:59`);
            this.startTimeEnabled = false;
            this.endTimeEnabled = false;
            break;
          case '1':
            this.startTimeForSingle = new Date(`${DateUtil.getYesterdayYearMonthDay()} 00:00:00`);
            this.endTimeForSingle = new Date(`${DateUtil.getYesterdayYearMonthDay()} 23:59:59`);
            this.startTimeEnabled = false;
            this.endTimeEnabled = false;
            break;
          case '2':
            this.startTimeForSingle = new Date(`${DateUtil.getCurrentWeekBeginYearMonthDay()} 00:00:00`);
            this.endTimeForSingle = new Date(`${DateUtil.getCurrentWeekEndYearMonthDay()} 23:59:59`);
            this.startTimeEnabled = false;
            this.endTimeEnabled = false;
            break;
          case '3':
            this.startTimeForSingle = new Date(`${DateUtil.getLastWeekBeginYearMonthDay()} 00:00:00`);
            this.endTimeForSingle = new Date(`${DateUtil.getLastWeekEndYearMonthDay()} 23:59:59`);
            this.startTimeEnabled = false;
            this.endTimeEnabled = false;
            break;
          case '4':
            this.startTimeForSingle = '';
            this.endTimeForSingle = '';
            this.startTimeEnabled = true;
            this.endTimeEnabled = true;
            break;
          default:
            break;
        }
      },

      validateOfNoRealMeasurementReport() {
        const formStatus = this.formObjOfNoRealSingleReport.validate();
        if (!formStatus) {
          return false;
        }
        return true;
      },

      bindValidateOfMeasurementReport() {
        this.formObjOfNoRealSingleReport = new FormValidator('#noRealSingleReport', this.optionsOfNoRealSingleReportDialogValidation);
      },

      measureObjSelectedOfMeasurementReport(args) {
        this.measureObjCodeOfSingleReport = args.data.measureObjCode;
        this.$refs.NoRealTaskMeasureTreeForSingleReport.getMeasureTreeForSingleReport(this.selectNeType,args.data.measureObjCode);
      },

      getMeasureListForMeasurementReport(neTypeCode){
        const params = {
          neTypeCode
        }
        this.$axios.get(`/lte/ems/pm/noReal/query/buildNoRealTaskMeasureObjListForQuery.html${CommonUtil.analyticParameter(params)}`).then((response) => {
          this.measureObjDataSourceOfSingleReport =response.data;
        });
      },
    },
    mounted() {
      this.bindValidateOfMeasurementReport();
    }
  }
</script>

<style scoped>
  .h-dialogContainer .h-col-inputBox-left {
    margin-bottom: 18px;
    padding-left: 35px;
    padding-right: 10px;
  }

  .h-dialogContainer .h-col-inputBox-middle {
    margin-top: 25px;
    margin-bottom: 5px;
  }

  .h-dialogContainer .h-col-inputBox-right {
    margin-bottom: 18px;
    padding-left: 10px;
    padding-right: 35px;
  }

  .h-dialogContainer >>> .e-listview .e-list-item.e-active{
    background-color: #007bff;
    color: #fff;
  }
</style>
